import { InjectedContentBlock } from "@omni/types/api/search/bff/injectedContentBlock.model";
import { AdvisorMode } from "@omni/types/components/aiden/advisorMode.enum";
import { SearchResultsStyle } from "@omni/ui/components/Search/SearchResults/searchResults.style";

import { ContentBlockComponent } from "./contentBlock.component";
import { ContentBlockButton } from "./contentBlockButton.component";
import { ContentBlockLink } from "./contentBlockLink.component";

type ContentBlockComponentProps = {
    content: InjectedContentBlock;
};

const ContentBlock = ({ content }: ContentBlockComponentProps) => {
    const expandImage = !!(
        content.imageUrl &&
        !content.title &&
        !content.description
    );

    return content.aidenAdvisorId ? (
        <ContentBlockButton
            className={SearchResultsStyle.resultList.contentBlock({
                expandImage: expandImage
            })}
            data-advisor-id={content.aidenAdvisorId}
            data-aiden-mode={
                content.aidenAdvisorMode === AdvisorMode.Ai
                    ? "ai-sidebar"
                    : "sidebar"
            }
        >
            <ContentBlockComponent
                content={content}
                expandImage={expandImage}
            />
        </ContentBlockButton>
    ) : (
        <ContentBlockLink
            className={SearchResultsStyle.resultList.contentBlock({
                expandImage: expandImage
            })}
            url={content.url}
        >
            <ContentBlockComponent
                content={content}
                expandImage={expandImage}
            />
        </ContentBlockLink>
    );
};

export { ContentBlock };
